import Api from './rest/TaskStatusApi';

export default new Api();
